// extracted by mini-css-extract-plugin
export default {"container":"AddOffer_container__lTBIG"};